<template>
    <b-form @submit.prevent="submit">
        <b-alert :show="!!errorMessage" fade :variant="errorVariant">{{errorMessage}}</b-alert>

        <b-input type="text" v-model.trim="scanValue" class="d-inline-block mr-2" :key="isProcessing /*For re-triggering the autofocus*/"
                 style="width:230px;"
                 placeholder="EAN code"
                 required autofocus autocomplete="off"
                 :disabled="isProcessing"
                 ref="valueInput"
        />
        <b-button variant="primary" type="submit" :disabled="isProcessing">
            <span v-if="!isProcessing">Scan</span>
            <font-awesome-icon v-else icon="spinner" spin/>
        </b-button>
    </b-form>
</template>

<script>
import {UsesProductProcessApi} from "./UsesProductProcessApi";
import {PRODUCT_PROCESS_TYPE_RETURN, PRODUCT_PROCESS_TYPE_SORT} from "../../../data/productProcessType";

export default {
    name: "ProductScanReturn",

    data() {
        return {
            isProcessing: false,
            scanValue: '',
            errorVariant: '',
            errorMessage: '',
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 500),
        }
    },

    computed: {},

    mounted() {
    },
    beforeDestroy() {
        clearInterval(this.refocusInterval)
    },

    methods: {
        submit() {
            clearInterval(this.refocusInterval);
            this.$emit('success', this.scanValue.padStart(13, '0'))
        },
    },
}
</script>

<style scoped>

</style>
